import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import { inject } from '@angular/core';
import {AuthenticationService} from "./authentication.service";
import {catchError, throwError} from "rxjs";
import {authActions} from "../../state/auth/auth.actions";
import {Store} from "@ngrx/store";

export const AuthHttpInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthenticationService);
    const store = inject(Store)
    const token = authService.getAuthenticationToken(); // Retrieve your JWT
    let request = req
    if (token) {
        request = req.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`
            }
        });
    }
    return next(request).pipe(
        catchError((error: HttpErrorResponse) => {
            // 401 indicates the token is invalid or expired on the server
            if (error.status === 401) {
                store.dispatch(
                    authActions.logoutUser(),
                );
            }
            return throwError(() => error);
        }))
};
